import React from 'react';
import { Moment } from 'moment';
import SideFilter from '../../../../../Components/Filter/SideFilter';
import SideFilterForm from '../../../../../Components/Filter/SideFilterForm/SideFilterForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import { NCZIReference } from '../../../Interfaces/ncziTypes';

export interface ElectronicVaccinationFilterValues {
	reactionDateFrom?: Moment;
	reactionDateTo?: Moment;
	executionDateFrom?: Moment;
	executionDateTo?: Moment;
	writeDateFrom?: Moment;
	writeDateTo?: Moment;
	includeCancelled?: boolean;
	onlyOwnRecords?: boolean;
	onlyVaccinationWithReaction?: boolean;
	atcGroup?: string;
	vaccinationKind?: NCZIReference;
	vaccinationType?: NCZIReference;
	vaccinationId?: string;
	recordId?: string;
}

const ElectronicVaccinationFilterScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.vaccination.filter.writeDateLabel',
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.vaccination.filter.writeDateFrom',
		key: 'writeDateFrom',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.vaccination.filter.writeDateTo',
		key: 'writeDateTo',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.vaccination.filter.recordsLabel',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.vaccination.filter.includeCancelled',
		key: 'includeCancelled',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.vaccination.filter.onlyOwnRecords',
		key: 'onlyOwnRecords',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.vaccination.filter.onlyVaccinationWithReaction',
		key: 'onlyVaccinationWithReaction',
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.vaccination.filter.vaccinationLabel',
	},
	{
		type: MagicField.NZCI_VACCINATION_KIND,
		title: 'nczi.vaccination.filter.vaccinationKind',
		key: 'vaccinationKind',
	},
	{
		type: MagicField.NZCI_VACCINATION_TYPE,
		title: 'nczi.vaccination.filter.vaccinationType',
		key: 'vaccinationType',
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.vaccination.filter.executionLabel',
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.vaccination.filter.executionDateFrom',
		key: 'executionDateFrom',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.vaccination.filter.executionDateTo',
		key: 'executionDateTo',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.vaccination.filter.reactionLabel',
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.vaccination.filter.reactionDateFrom',
		key: 'reactionDateFrom',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.vaccination.filter.reactionDateTo',
		key: 'reactionDateTo',
		settings: {
			hideRequired: true,
		},
	},
];

interface Props {
	onFilter: (values: ElectronicVaccinationFilterValues) => void;
}

const ElectronicVaccinationFilter: React.FC<Props> = ({ onFilter }) => {
	const handleOnSubmit = (values: any) => {
		if (values.vaccinationKind) {
			values.vaccinationKind = values.vaccinationKind.value;
		}
		if (values.vaccinationType) {
			values.vaccinationType = values.vaccinationType.value;
		}
		onFilter(values as ElectronicVaccinationFilterValues);
	};

	return (
		<SideFilter isOpenByDefault={false}>
			<SideFilterForm
				onSubmit={handleOnSubmit}
				formScheme={ElectronicVaccinationFilterScheme}
				defaultValues={{}}
			/>
		</SideFilter>
	);
};

export default ElectronicVaccinationFilter;
